import { PostulacionModel } from "../../models/PostulacionesModel/postulacion.model";
import  types  from "../types/types";

interface modelidjurados {
  idJurado: number;
  editarJurado: boolean;
  juradoPostulado: string;
  invitacionJurado: boolean;
  setModalJuryPostulate: boolean;
  jurados: Array<PostulacionModel>;
  educacion: number;
  jurado_atras: boolean;
  menuJurado: boolean;
  sec: any,
  proyectosAsignados: any
}

const initialmodelidjurados: modelidjurados = {
  idJurado: 0,
  editarJurado: false,
  juradoPostulado: "Sin verificar",
  invitacionJurado: false,
  setModalJuryPostulate: false,
  jurados: [],
  educacion: 0,
  jurado_atras: false,
  menuJurado: false,
  sec: '',
  proyectosAsignados: []
};

export const idjuradosReducer = (state = initialmodelidjurados, action: any) => {

  switch (action.type) {
    case types.id_jurado:
      return {
        ...state,
        idJurado: action.payload.idJurado,
      };
    case types.editar_jurado:
      return {
        ...state,
        editarJurado: action.payload.editarJurado,
      };
    case types.jurado_postulado:
      return {
        ...state,
        newState: action.payload,
      };
    case types.invitacion_jurado:
      return {
        ...state,
        invitacionJurado: action.payload.invitacionJurado,
      };
    case types.setModalJuryPostulate:
      return {
        ...state,
        setModalJuryPostulate: action.payload.setModalJuryPostulate,
      };
    case types.jurados_criterios:
      return {
        ...state,
        jurados: action.payload.jurados,
      };
    case types.jurado_educacion: 
      return {
        ...state,
        educacion: action.payload.educacion
      };
    case types.jurados_atras:
      return {
        ...state,
        jurado_atras: action.payload.jurado_atras
      }
    case types.menu_jurado:
      return {
        ...state,
        menuJurado: action.payload.menuJurado
      }
    case types.sec:
      return {
        ...state,
        sec: action.payload.sec
      }
    case types.proyectosAsignados:
      return {
        ...state,
        proyectosAsignados: action.payload.proyectosAsignados
      }
    default:
      return state;
  }
};
